import * as swcHelpers from '@swc/helpers';
import { takeLatest, select, put } from 'redux-saga/effects';
import { ORDER_CREATE_SUCCESS } from '../../actions.js';
import { updatePaymentDetails } from '../actions.js';
import { getPaymentDetails } from '../selectors.js';
import { getGraphQLPaymentProviderName } from '../utils/get-payment-provider-name.js';
import { getGraphQLPaymentMethodName } from '../utils/get-payment-method-name.js';

function* onOrderCreateSuccess(action) {
    const paymentDetails = yield select(getPaymentDetails);
    const { paymentServiceProvider , paymentMethod , resultDetails  } = action.payload.order.paymentResponse;
    if (paymentDetails) {
        const methods = paymentDetails[paymentServiceProvider];
        const existing = methods && methods[paymentMethod];
        yield put(updatePaymentDetails(swcHelpers.objectSpread({
            provider: getGraphQLPaymentProviderName(paymentServiceProvider)
        }, existing || {
            data: {},
            isValid: true
        }, {
            type: getGraphQLPaymentMethodName(paymentMethod),
            result: resultDetails
        })));
    }
}
var paymentMethodsSagas = [
    takeLatest(ORDER_CREATE_SUCCESS, onOrderCreateSuccess)
];

export { paymentMethodsSagas as default, onOrderCreateSuccess };
//# sourceMappingURL=sagas.js.map
